// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import HeatMapOutlinedSvg from "@ant-design/icons-svg/es/asn/HeatMapOutlined";
import AntdIcon from '../components/AntdIcon';

var HeatMapOutlined = function HeatMapOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: HeatMapOutlinedSvg
  }));
};

HeatMapOutlined.displayName = 'HeatMapOutlined';
export default React.forwardRef(HeatMapOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/HeatMapOutlined.js
// module id = 1305
// module chunks = 0